// extracted by mini-css-extract-plugin
export default {"leftMenuOuterHolder":"LeftMenu_leftMenuOuterHolder__bSt8x","gameTitle":"LeftMenu_gameTitle__JrQSd","gameTitleText":"LeftMenu_gameTitleText__m9A3v"};